// Clés sessionStorage partagées entre intercepteur axios et LoginPage

export const AUTH_BLOCK_LOGIN_AUTO_REDIRECT = "auth:blockLoginAutoRedirect";

export function setBlockLoginAutoRedirect() {
  try {
    sessionStorage.setItem(AUTH_BLOCK_LOGIN_AUTO_REDIRECT, "1");
  } catch (_) {
    /* ignore */
  }
}

export function isBlockLoginAutoRedirect() {
  try {
    return sessionStorage.getItem(AUTH_BLOCK_LOGIN_AUTO_REDIRECT) === "1";
  } catch (_) {
    return false;
  }
}

export function clearBlockLoginAutoRedirect() {
  try {
    sessionStorage.removeItem(AUTH_BLOCK_LOGIN_AUTO_REDIRECT);
  } catch (_) {
    /* ignore */
  }
}
